<h4 class="dialog-title text-center">{{ 'Add User' | translate }}</h4>

<hr />

<app-progress-spinner [show]="isFormLoading"></app-progress-spinner>

<div class="mb-4">
  <div mat-dialog-content>
    <div class="row">
      <div class="col-md-12">
        <mat-form-field>
          <mat-label>{{ 'First Name' | translate }}</mat-label>
          <input matInput [(ngModel)]="data.firstName" required maxlength="100" />
          <mat-icon matPrefix class="mr-3">
            <i class="fas fa-address-card"></i>
          </mat-icon>
          <mat-error>
            {{ 'First Name is required' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-12">
        <mat-form-field>
          <mat-label>{{ 'Last Name' | translate }}</mat-label>
          <input matInput [(ngModel)]="data.lastName" required maxlength="100" />
          <mat-icon matPrefix class="mr-3">
            <i class="fas fa-address-card"></i>
          </mat-icon>
          <mat-error>
            {{ 'Last Name is required' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-12">
        <mat-form-field>
          <mat-label>{{ 'Username' | translate }}</mat-label>
          <input matInput [(ngModel)]="data.username" [type]="data.createAccount ? 'email' : 'text'"
            [email]="data.createAccount" #username="ngModel" required />
            <mat-icon matPrefix class="mr-3">
              <i class="fas fa-user"></i>
            </mat-icon>
            @if (username.errors?.required) {
              <mat-error>{{ 'Username is required' | translate }}</mat-error>
            }
            @if (username.errors?.email) {
              <mat-error>{{ 'Invalid email address' | translate }}</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="col-md-12 padding-y-10">
          <mat-checkbox color="primary" [(ngModel)]="data.createAccount">
            {{ 'Create account for this user' | translate }}
          </mat-checkbox>
          <mat-icon class="ml-1 color-primary-light" [title]="createAccountInfo">
            <i class="fas fa-info-circle"></i>
          </mat-icon>
          <hr class="field-underline" />
        </div>

        @if (data.createAccount) {
          <div class="col-md-12">
            <mat-form-field>
              <mat-label>{{ 'Role' | translate }}</mat-label>
              <mat-select [(ngModel)]="data.securityProfileId" [disabled]="!data.createAccount"
                [title]="data.createAccount ? '' : 'Disabled'" required class="cursor-not-allowed">
                @for (profile of securityProfiles; track trackById($index, profile)) {
                  <mat-option [value]="profile.id">
                    {{profile.value}}
                  </mat-option>
                }
              </mat-select>
              <mat-icon matPrefix class="mr-3">
                <i class="fas fa-user-tag"></i>
              </mat-icon>
              <mat-error>{{ 'Role is required' | translate }}</mat-error>
            </mat-form-field>
          </div>
        }
      </div>
    </div>

    <div mat-dialog-actions align="end">
      <button class="btn button-primary" mat-button (click)="save()" [class.button-spinner]="isLoading"
        [disabled]="!data.firstName || !data.lastName || username.invalid || (data.createAccount && data.securityProfileId === undefined) || isLoading">
        {{ 'Add' | translate }}
      </button>

      <button class="btn button-accent" mat-button mat-dialog-close>{{ 'Cancel' | translate }}</button>
    </div>
  </div>
